import { memo } from 'react';
import { CircularProgress, Grid } from '@mui/material';
import CurrencyFormat from 'components/ui/text-formats/CurrencyFormat';

const GeneralStatistics = ({ data }) => {
  const { square, product, expense, isLoading } = data;

  return (
    <div className='residential-complex-item income-by-residential-complex !shadow-md !base-border'>
      <div className='residential-complex-item-header mb-4'>
        <div className='residential-complex-item-title font-semibold text-lg income-by-residential-complex-title'>
          Umumiy sarf xarajat
        </div>
      </div>

      {isLoading ? (
        <div className='h-48 flex items-center justify-center'>
          <CircularProgress />
        </div>
      ) : (
        <Grid
          container
          spacing={2}
          columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
        >
          <Grid item={true} lg={3} md={3} sm={12} xs={12}>
            <div className='shadow-md p-2 border rounded-md w-full h-full'>
              <div className='font-semibold text-center'>Mahsulot sarfi</div>
              <div className='p-2 border shadow-md mt-2'>
                UZS:{' '}
                <CurrencyFormat
                  value={product?.object?.totalsum + product?.sum}
                  suffix=''
                  decimalScale={2}
                />
              </div>
              <div className='p-2 border shadow-md mt-2'>
                USD:{' '}
                <CurrencyFormat
                  value={product?.object?.totalval + product?.val}
                  suffix=''
                  decimalScale={2}
                />
              </div>
              <div className='p-2 border shadow-md mt-2'>
                Jami USD:{' '}
                <CurrencyFormat
                  value={product?.object?.invalute + product?.invalute}
                  suffix=''
                  decimalScale={2}
                />
              </div>
            </div>
          </Grid>
          <Grid item={true} lg={3} md={3} sm={12} xs={12}>
            <div className='shadow-md p-2 border rounded-md w-full h-full'>
              <div className='font-semibold text-center'>Xarajat</div>
              <div className='p-2 border shadow-md mt-2'>
                UZS:{' '}
                <CurrencyFormat
                  value={expense?.object?.totalsum + expense?.sum}
                  suffix=''
                  decimalScale={2}
                />
              </div>
              <div className='p-2 border shadow-md mt-2'>
                USD:{' '}
                <CurrencyFormat
                  value={expense?.object?.totalval + expense?.val}
                  suffix=''
                  decimalScale={2}
                />
              </div>
              <div className='p-2 border shadow-md mt-2'>
                Jami USD:{' '}
                <CurrencyFormat
                  value={expense?.object?.invalute + expense?.invalute}
                  suffix=''
                  decimalScale={2}
                />
              </div>
            </div>
          </Grid>
          <Grid item={true} lg={3} md={3} sm={12} xs={12}>
            <div className='shadow-md p-2 border rounded-md w-full h-full'>
              <div className='font-semibold text-center'>
                Umumiy sarf (mahsulot, xarajat)
              </div>
              <div className='p-2 border shadow-md mt-2'>
                UZS:{' '}
                <CurrencyFormat
                  value={
                    expense?.object?.totalsum +
                    expense?.sum +
                    product?.object?.totalsum +
                    product?.sum
                  }
                  suffix=''
                  decimalScale={2}
                />
              </div>
              <div className='p-2 border shadow-md mt-2'>
                USD:{' '}
                <CurrencyFormat
                  value={
                    expense?.object?.totalval +
                    expense?.val +
                    product?.object?.totalval +
                    product?.val
                  }
                  suffix=''
                  decimalScale={2}
                />
              </div>
              <div className='p-2 border shadow-md mt-2'>
                Jami USD:{' '}
                <CurrencyFormat
                  value={
                    expense?.object?.invalute +
                    expense?.invalute +
                    product?.object?.invalute +
                    product?.invalute
                  }
                  suffix=''
                  decimalScale={2}
                />
              </div>
            </div>
          </Grid>
          <Grid item={true} lg={3} md={3} sm={12} xs={12}>
            <div className='shadow-md p-2 border rounded-md w-full h-full'>
              <div className='font-semibold text-center'>
                m<sup>2</sup> kesmida
              </div>
              <div className='p-2 border shadow-md mt-2'>
                UZS:{' '}
                <CurrencyFormat
                  value={
                    (expense?.object?.totalsum +
                      expense?.sum +
                      product?.object?.totalsum +
                      product?.sum) /
                    square
                  }
                  suffix=''
                  decimalScale={2}
                />
              </div>
              <div className='p-2 border shadow-md mt-2'>
                USD:{' '}
                <CurrencyFormat
                  value={
                    (expense?.object?.totalval +
                      expense?.val +
                      product?.object?.totalval +
                      product?.val) /
                    square
                  }
                  suffix=''
                  decimalScale={2}
                />
              </div>
              <div className='p-2 border shadow-md mt-2'>
                Jami USD:{' '}
                <CurrencyFormat
                  value={
                    (expense?.object?.invalute +
                      expense?.invalute +
                      product?.object?.invalute +
                      product?.invalute) /
                    square
                  }
                  suffix=''
                  decimalScale={2}
                />
              </div>
            </div>
          </Grid>
        </Grid>
      )}
    </div>
  );
};

export default memo(GeneralStatistics);
